import { useEffect, useRef, useState, useCallback } from 'react'

export function useIsOverflow(deps: any[] = []) {
  const ref = useRef<HTMLElement>(null)
  const [isOverflow, setIsOverflow] = useState(false)

  const check = useCallback(() => {
    const el = ref.current
    if (!el) return
    requestAnimationFrame(() => {
      const node = ref.current
      if (!node) return
      setIsOverflow(node.scrollWidth > node.clientWidth)
    })
  }, [])

  useEffect(() => {
    const el = ref.current
    if (!el) return

    check()
    const raf = requestAnimationFrame(check)

    const ro = new ResizeObserver(check)
    ro.observe(el)
    if (el.parentElement) ro.observe(el.parentElement)
    const mo = new MutationObserver(check)
    mo.observe(el, { characterData: true, childList: true, subtree: true })

    if ((document as any).fonts?.ready) {
      (document as any).fonts.ready.then(check).catch(() => {})
    }

    return () => {
      ro.disconnect()
      mo.disconnect()
      cancelAnimationFrame(raf)
    }
  }, deps)

  return { ref, isOverflow, recompute: check }
}
